import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import axios from "axios";

import { ReactComponent as CrossSvg } from "assets/images/heylime-layout/cross.svg";
import Alert from "components/shared/common/alert";
import OnboardingModal from "components/heylime-layout/components/OnboardingModal";
import { setIsLoading } from "redux/loader/action";
import { set_invite_teammate_array } from "redux/signin/action";

const InviteTeammates = () => {
  const dispatch = useDispatch();
  const {
    gameReducer: { currentUser },
    signinReducer: { invite_teammate_array }
  } = useSelector((state) => state);

  const [inviteLinkUrl, setInviteLinkUrl] = useState("");
  const [email, setEmail] = useState("");

  const handleIsLoading = (value) => dispatch(setIsLoading(value));
  const toggleModal = () => setInviteLinkUrl("");

  const addEmail = () => {
    const email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!email_regex.test(email)) {
      Alert(400, "Please enter a valid email address.");
    } else {
      if (invite_teammate_array.some((item) => item === email)) {
        Alert(400, "Duplicate email address.");
      } else {
        dispatch(
          set_invite_teammate_array([...invite_teammate_array, email.trim()])
        );
        setEmail("");
      }
    }
  };

  const deleteEmail = (email) => {
    let email_array = [...invite_teammate_array];
    email_array = email_array.filter((item) => item !== email.trim());
    dispatch(set_invite_teammate_array(email_array));
  };

  const handleFinish = async () => {
    if (!isEmpty(invite_teammate_array)) {
      try {
        handleIsLoading(true);
        const url = process.env.REACT_APP_SEND_TEAM_INVITE;
        const response = await axios.post(url, {
          team_code: currentUser.team.id,
          inviter_user_id: currentUser.userId,
          invites: invite_teammate_array
        });
        if (response.data.status === "Success") {
          dispatch(set_invite_teammate_array([]));
          Alert(200, "Invite sent successfully.");
        }
      } catch (error) {
        console.log("error: ", error);
      } finally {
        handleIsLoading(false);
      }
    } else {
      Alert(400, "Please add email.");
    }
  };

  const getMagicLink = async () => {
    handleIsLoading(true);
    let url = process.env.REACT_APP_GET_MAGIC_LINK;
    url = `${url}?team_code=${currentUser.team.id}&user_name=${currentUser.username}`;
    try {
      const response = await axios.get(url);
      toggleModal();
      setInviteLinkUrl(response.data.url);
    } catch (error) {
      console.error(error, "error");
    } finally {
      handleIsLoading(false);
    }
  };

  const handleCopyLink = () =>
    navigator.clipboard
      .writeText(inviteLinkUrl)
      .then(() => {
        Alert(200, "Link copied successfully");
      })
      .catch((error) => {
        console.error("Error copying to clipboard:", error);
      });

  const handleShareLink = () =>
    (window.open().location.href = `mailto:?subject= You're invited to a heyLIME team! &body=You’ve been invited to a heyLIME team!%0DTeam: ${currentUser.team.description}%0DClick on the link below to join your team (link expires in 72 hours):%0D${inviteLinkUrl}`);

  return (
    <div className="invite-teammates-main">
      <h2 className="title">Invite Teammates</h2>
      <p className="desc">
        Invite teammates to join you on heylime via email or by sharing an
        invite link.{" "}
        <span className="invite" onClick={getMagicLink}>
          Get Link
        </span>
      </p>
      <div className="add-email">
        <input
          name="email"
          type="email"
          value={email}
          className="input-div"
          placeholder="Teammate Email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          className={`onboarding-button small-btn`}
          disabled={isEmpty(email)}
          onClick={addEmail}
        >
          Add
        </button>
      </div>{" "}
      {!isEmpty(invite_teammate_array) && (
        <div className="email-parent">
          {invite_teammate_array.map((email, index) => (
            <div key={index} className="email-container">
              <h2>{email}</h2>
              <CrossSvg
                onClick={() => deleteEmail(email)}
                className="cross-icon"
              />
            </div>
          ))}
        </div>
      )}
      <button className="onboarding-button" onClick={handleFinish}>
        Finish
      </button>
      <OnboardingModal
        inputType="text"
        inputDisabled={true}
        toggle={toggleModal}
        btnText1="Copy Link"
        btnText2="Share Link"
        btnClick1={handleCopyLink}
        inputValue={inviteLinkUrl}
        btnClick2={handleShareLink}
        isOpen={!isEmpty(inviteLinkUrl)}
        title="Share this link to invite your team"
        desc="Teammates can use this link to sign up and join your team. (Expires in 72 hours):"
      />
    </div>
  );
};

export default InviteTeammates;
